import React, { useEffect, useState } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { Popover, Modal } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import images from "../../../themes/appImage";
import { userCommentListLoad } from "../../../redux/slices/user.slice";
import { imageURL } from "../../../redux/Api/apikit";


const apiPayloadInit = {
  offset: 0,
  limit: 10
}
const Post = ({
  avatarSrc,
  file,
  postType,
  username,
  time,
  description,
  happyFace,
  partyFace,
  redHeart,
  smileyFace,
  smileyHeart,
  comment,
  id,
}) => {
  const fileString = `${imageURL}${file}`;
  const dispatch = useDispatch();
  const { commentListData } = useSelector(state => state.userReducer);
  const [visible, setVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [commentsList, setCommentsList] = useState([])
  const [apiPayload, setApiPayload] = useState(apiPayloadInit)

  useEffect(() => {
    setCommentsList(pre => [...commentsList, ...commentListData])
  }, [commentListData])
  const commentsPerPage = 5;

  const handelClick = () => {
    setApiPayload(pre => apiPayloadInit)
    setCommentsList(pre => [])
    setIsModalVisible(true);
    const data = {
      ...apiPayload,
      post: id
    };
    dispatch(userCommentListLoad(data));
  };

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClose = () => {
    setApiPayload(pre => apiPayloadInit)
    setCommentsList(pre => [])

    setIsModalVisible(false);
    setCurrentPage(1); // Reset to first page when closing the modal
  };

  const content = (
    <div className="flex items-center">
      <div className="mr-2 flex gap-1">
        <img src={images.hug} alt="hug" />
        <div className="text-[#2F2F2FCC]">{smileyFace}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.EyeBrows} alt="eyebrows" />
        <div className="text-[#2F2F2FCC]">{happyFace}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.love} alt="love" />
        <div className="text-[#2F2F2FCC]">{redHeart}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.party} alt="party" />
        <div className=" text-[#2F2F2FCC]">{partyFace}</div>
      </div>
      <div className="mr-2 flex gap-1">
        <img src={images.smileyHeart} alt="smileyHeart" />
        <div className=" text-[#2F2F2FCC]">{smileyHeart}</div>
      </div>
    </div>
  );

  const indexOfLastComment = currentPage * commentsPerPage;
  const indexOfFirstComment = indexOfLastComment - commentsPerPage;
  const currentComments = commentListData.slice(indexOfFirstComment, indexOfLastComment);

  const handlerShowMoreCommentsHandler = () => {
    const updateOffset = apiPayload.offset + apiPayload.limit
    const data = {
      ...apiPayload,
      offset: updateOffset,
      post: id
    };
    dispatch(userCommentListLoad(data));
    setApiPayload(pre => ({ ...pre, offset: updateOffset }))
  }
  return (
    <div className="border border-royalPurple rounded-[20px]">
      <div className="p-4">
        <div className="flex gap-2 mb-2">
          <div>
            <img
              src={avatarSrc}
              alt="avatar"
              className="w-[40px] h-[40px] object-contain"
            />
          </div>
          <div className="flex flex-col justify-between">
            <div className="text-sm font-semibold text-dark">{username}</div>
            <div className="text-xs text-gray60 font-normal">
              {moment(time).utc().fromNow()}
            </div>
          </div>
        </div>
        <div className="text-base font-normal break-words text-dark mb-4">
          {description}
        </div>
      </div>
      <div>
        {postType === "videoOnly" ? (
          <video width="600" controls>
            <source src={fileString} type="video/mp4" />
          </video>
        ) : postType === "postOnly" ? (
          <img
            src={fileString}
            alt="cover"
            className="w-full h-full object-cover"
          />
        ) : null}
      </div>
      <div className="flex justify-between items-center p-4">
        <div className="flex justify-center items-center gap-2">
          <div>
            <EllipsisOutlined />
          </div>
          <Popover
            content={content}
            trigger="click"
            open={visible}
            onOpenChange={handleVisibleChange}
          >
            <div
              className="bg-background flex"
              onClick={() => handleVisibleChange(!visible)}
            >
              <div>
                <img src={images.hug} alt="hug" />
              </div>
              <div>
                <img src={images.EyeBrows} alt="eyebrows" />
              </div>
              <div>
                <img src={images.love} alt="love" />
              </div>
            </div>
          </Popover>
          <div className="text-gray60 font-normal cursor-pointer" onClick={handelClick}>
            {comment} Comments
          </div>
        </div>
        <div className="flex items-center gap-2">
          {/* <div className="bg-background rounded-full my-shadow p-2">
            <img src={images.commentImg} alt="comment" />
          </div>
          <div className="bg-purple rounded-full my-shadow p-2">
            <img src={hugSrc} alt="emoji" />
          </div> */}
        </div>
      </div>

      <Modal
        title="Comments"
        open={isModalVisible}
        onCancel={handleClose}
        footer={null}
        centered
      >
        <div className="h-80 overflow-scroll">
          {commentsList && commentsList?.length > 0 ? (
            commentsList.map((comment) => (
              <div key={comment._id} className="mb-4">
                <div className="flex items-center mb-2">
                  <img
                    src={`${imageURL}${comment?.userDetail?.avatar}`}
                    alt="avatar"
                    className="w-[40px] h-[40px] object-contain mr-2"
                  />
                  <div className="flex flex-col">
                    <div className="text-sm font-semibold">
                      {comment?.userDetail?.userName}
                    </div>
                    <div className="text-xs text-gray60 font-normal">
                      {moment(comment?.createdAt).utc().fromNow()}
                    </div>
                  </div>
                </div>
                <div className="text-base font-normal text-dark">
                  {comment?.comment}
                </div>
              </div>
            ))
          ) : (
            <div className="w-full text-center">No comments</div>
          )}
        </div>
        {commentListData.length >= apiPayload.limit && <div className=" flex mt-3 justify-center">
          <div onClick={handlerShowMoreCommentsHandler} className="cursor-pointer border border-black rounded-md p-1 px-2 text-sm text-black">Show more</div>
        </div>}
      </Modal>
    </div>

  );
};

export default Post;
